import { type FC } from 'react';
import { Form } from 'react-bootstrap';

interface Props {
	figureProperties: any;
	onChange: (_) => void;
}

const BigQuoteEpigraphForm: FC<Props> = (props) => {
	const { figureProperties, onChange } = props;

	return (
		<>
			<Form.Group>
				<Form.Label>Quote</Form.Label>
				<Form.Control
					as="textarea"
					rows={3}
					value={figureProperties.quote_text}
					placeholder="Love isn’t a state of perfect caring. It is an active noun like “struggle.” 
                    To love someone is to strive to accept that person exactly the way he or she is, right here and now."
					onChange={(e) => onChange({ quote_text: e.target.value })}
				/>
			</Form.Group>

			<Form.Group>
				<Form.Label>Who said it</Form.Label>
				<Form.Control
					value={figureProperties.quote_author}
					placeholder="Fred Rogers"
					onChange={(e) => onChange({ quote_author: e.target.value })}
				/>
			</Form.Group>

			<Form.Group>
				<Form.Label>Citation</Form.Label>
				<Form.Control
					value={figureProperties.quote_citation}
					placeholder="Citation"
					onChange={(e) => onChange({ quote_citation: e.target.value })}
				/>
			</Form.Group>
		</>
	);
};

export default BigQuoteEpigraphForm;
